import type { Editor } from '@tiptap/core';
import { forwardRef } from 'react';
import RichTextEditor from 'reactjs-tiptap-editor';
import {
  BaseKit,
  Blockquote,
  Bold,
  BulletList,
  Clear,
  Color,
  Emoji,
  FontFamily,
  FontSize,
  Heading,
  Highlight,
  History,
  HorizontalRule,
  Image,
  Indent,
  Italic,
  LineHeight,
  Link,
  OrderedList,
  Strike,
  Table,
  TaskList,
  TextAlign,
  TextDirection,
  Underline,
} from 'reactjs-tiptap-editor/extension-bundle';
// Import CSS
import 'reactjs-tiptap-editor/style.css';

const extensions = [
  BaseKit.configure({
    hardBreak: {
      keepMarks: true,
    },
  }),
  History,
  // SearchAndReplace,
  // TableOfContents,
  // FormatPainter.configure({ spacer: true }),
  Clear,
  FontFamily,
  Heading.configure({ spacer: true }),
  FontSize,
  Bold,
  Italic,
  Underline,
  Strike,
  // MoreMark,
  // Katex,
  Emoji,
  Color.configure({ spacer: true }),
  Highlight,
  BulletList,
  OrderedList,
  TextAlign.configure({ types: ['heading', 'paragraph'], spacer: true }),
  Indent,
  LineHeight,
  TaskList.configure({
    spacer: true,
    taskItem: {
      nested: true,
    },
  }),
  Link,
  Image.configure({
    upload: (files: File) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(URL.createObjectURL(files));
        }, 500);
      });
    },
  }),
  Blockquote,
  // SlashCommand,
  HorizontalRule,
  // ENR-1641: keep receipt item tables intact in system email editor defaults
  Table.configure({
    resizable: false,
  }),

  TextDirection,
  // Mention,
];

export interface TextEditorProps {
  content: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeContent: ((val: any) => void) | undefined;
}

/** Matches reactjs-tiptap-editor's imperative handle. */
export type TextEditorRef = {
  editor: Editor | null;
};

export const TextEditor = forwardRef<TextEditorRef, TextEditorProps>(
  function TextEditor({ content, onChangeContent }, ref) {
    return (
      <RichTextEditor
        ref={ref}
        output='html'
        content={content}
        onChangeContent={onChangeContent}
        extensions={extensions}
        dark={false}
      />
    );
  },
);
